import { IPartnerItem, TAdvertisementItem } from 'types';

import { IModalAdvertisementViewState } from '../../interfaces';

export enum EAdvertisementCategories {
  ALL = 'ALL',
  GOODS = 'GOODS',
  SERVICES = 'SERVICES',
}

export interface IAllAdvertisements {
  allAds?: TAdvertisementItem[];
  partners?: IPartnerItem[];
  loading: boolean;
  setAdvertisementCategories: React.Dispatch<
    React.SetStateAction<EAdvertisementCategories>
  >;
  advertisementCategories: EAdvertisementCategories;
  setAdvertisementViewState: React.Dispatch<
    React.SetStateAction<IModalAdvertisementViewState | null>
  >;
  searchStr?: string;
}
